import { render, staticRenderFns } from "./contact-detail-panel.vue?vue&type=template&id=5bdd29f0&scoped=true"
import script from "./contact-detail-panel.vue?vue&type=script&lang=js"
export * from "./contact-detail-panel.vue?vue&type=script&lang=js"
import style0 from "./contact-detail-panel.vue?vue&type=style&index=0&id=5bdd29f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd29f0",
  null
  
)

export default component.exports